// lazysizes force-unveils every .lazyload element for (gle|ing)bot UAs before any
// visibility/data-expand check (supportScroll, lazysizes.js), bypassing the map's
// display:none bot-hiding — cancel the unveil so hidden bot maps never hit Mapbox.
// https://github.com/halalbooking/halalbooking/pull/29275#discussion_r3577700528
;(() => {
  document.addEventListener("lazybeforeunveil", (e) => {
    if (e.target.closest(".place-info_bot .place-info-map")) {
      e.preventDefault()
    }
  })
})()
